<template>
  <div class="navbar-start">
    <router-link
      :to="{ name: 'admin-submissions'}"
      class="navbar-item"
    >
      <span class="item"><span><VideoOutline />&nbsp;</span>Submissions</span>
    </router-link>

    <router-link
      :to="{ name: 'admin-users', query: { type: 'participant' } }"
      class="navbar-item"
    >
      <span class="item"><span><AccountMultiple />&nbsp;</span>Participants</span>
    </router-link>

    <router-link
      :to="{ name: 'admin-users', query: { type: 'judge' } }"
      class="navbar-item"
    >
      <span class="item"><span><Gavel />&nbsp;</span>Judges</span>
    </router-link>

    <router-link
      :to="{ name: 'admin-events'}"
      class="navbar-item"
    >
      <span class="item"><span><TrophyVariantOutline />&nbsp;</span>Events</span>
    </router-link>

    <router-link
      :to="{ name: 'admin-divisions'}"
      class="navbar-item"
    >
      <span class="item"><span><FormatListBulletedSquare />&nbsp;</span>Divisions</span>
    </router-link>
  </div>
</template>

<script>
import VideoOutline from 'vue-material-design-icons/VideoOutline.vue'
import AccountMultiple from 'vue-material-design-icons/AccountMultiple.vue'
import Gavel from 'vue-material-design-icons/Gavel.vue'
import TrophyVariantOutline from 'vue-material-design-icons/TrophyVariantOutline.vue'
import FormatListBulletedSquare from 'vue-material-design-icons/FormatListBulletedSquare.vue'

export default {
  name: 'AdminMenu',
  components: {
    VideoOutline,
    AccountMultiple,
    Gavel,
    TrophyVariantOutline,
    FormatListBulletedSquare
  }
}
</script>

<style scoped>
  .d-none{
    display: none;
  }
</style>
